const liveBroadcastLink = state => state.liveBroadcastLink;
const scheduledLiveBroadcast = state => state.scheduledLiveBroadcast;
const schedules = state => state.schedules;

export {
  liveBroadcastLink,
  scheduledLiveBroadcast,
  schedules,
}